/**
 * Brain chat history API (private work log).
 *
 * The token is injected by the global fetch wrapper in services/auth.js, so these are
 * plain fetches. All four endpoints are scoped server-side to the calling user.
 *
 * A conversation is created lazily by the backend on the first saved turn — there is no
 * "create session" call and therefore no empty sessions.
 */

import asArray from '../utils/asArray';

const BASE = '/api/rag/sessions';

async function parse(res) {
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* empty or non-JSON body */
  }
  if (!res.ok) {
    const message = data?.detail || `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data;
}

export async function listSessions(limit = 50) {
  const res = await fetch(`${BASE}?limit=${encodeURIComponent(limit)}`);
  const data = await parse(res);
  return asArray(data?.sessions);
}

export async function loadSession(sessionId) {
  const res = await fetch(`${BASE}/${encodeURIComponent(sessionId)}`);
  return parse(res);
}

export async function renameSession(sessionId, title) {
  const res = await fetch(`${BASE}/${encodeURIComponent(sessionId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title }),
  });
  return parse(res);
}

export async function deleteSession(sessionId) {
  const res = await fetch(`${BASE}/${encodeURIComponent(sessionId)}`, { method: 'DELETE' });
  return parse(res);
}

export default { listSessions, loadSession, renameSession, deleteSession };
